'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

// Version is injected at build time from package.json via next.config.ts
const VERSION = process.env.NEXT_PUBLIC_APP_VERSION;

export function Footer() {
  const currentYear = new Date().getFullYear();
  const pathname = usePathname();

  // On chat pages, hide footer completely (disclaimer is in multimodal input)
  if (pathname === '/chat' || pathname?.startsWith('/chat/')) {
    return null;
  }

  // On other pages, show full footer
  return (
    <footer className="border-t border-border bg-background py-1 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-0.5 text-xs text-muted-foreground leading-tight">
          <div className="text-center" title={`v${VERSION}`}>
            © {currentYear} Rowmantic. All rights reserved.
          </div>
          <span className="hidden sm:inline text-muted-foreground/50">•</span>
          <a
            href="https://ravelry.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Powered by Ravelry
          </a>
          <span className="text-muted-foreground/50">•</span>
          <Link
            href="/privacy-policy"
            className="hover:text-foreground transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
